<template>
	<div v-if="repeaterMappedValue && repeaterMappedValue.length" class="repeater-content -mx-6">
		<perfect-scrollbar
			ref="vueScrollBar"
			:options="options"
			class="scroll-area--data-list"
		>
			<vs-table
				ref="table"
				class="stack-table custom-table-draggable repeater-table"
				:sst="true"
				:data="repeaterMappedValue"
				:noDataText="$t('Notify.NoDataAvailable')"
			>
				<template slot="thead">
					<vs-th v-if="isEditable"></vs-th>
					<vs-th v-for="(title, index) in stepTitles" :key="index">{{ title }}</vs-th>
				</template>

				<draggable v-model="repeaterMappedValue" :delay="200" :delayOnTouchOnly="true" tag="tbody" @end="data => $emit('onSort', data)">
					<tr :key="indextr" v-for="(form, indextr) in repeaterMappedValue" class="cursor-pointer" @click="$emit('onClickRepeaterData', value, indextr)">
						<vs-td v-if="isEditable">
							<i class="nucleo nucleo-trash-can cursor-pointer" @click.stop="$emit('onRemoveItem', indextr, value)"></i>
						</vs-td>
						<vs-td
							:key="index"
							:data-header="field.title"
							v-for="(field, index) in form"
							:class="{ 'img-container': field.control === $constant.request.control.attach }"
						>
							<!-- ATTACH FILE -->
							<div class="inline-block" v-if="field.control === $constant.request.control.attach" @click.stop>
								<cbs-upload-ref
									class="max-w-xs"
									v-if="field.value && field.value.length > 0"
									displayMode="list"
									:isEditable="false"
									:value="(field.value || []).map(fileId => mappedAttachObj[fileId])"
								/>
							</div>

							<!-- TEXT -->
							<!-- DATETIME PICKER -->
							<!-- AUTOFILL -->
							<div
								class="flex"
								v-if="
									field.control === $constant.request.control.autofill ||
									field.control === $constant.request.control.text ||
									field.control === $constant.request.control.datetime
								"
							>
								<div v-if="field.control !== $constant.request.control.datetime" class="text-black" v-text="field.value"></div>
								<div v-else class="text-black">{{ field.value | dateTime(userDateTimeFormat) }}</div>
							</div>

							<!-- TEXTAREA -->
							<div
								class="flex"
								v-if="field.control === $constant.request.control.textarea"
							>
								<div class="text-black whitespace-pre-wrap" v-html="field.value"></div>
							</div>

							<!-- NUMBER -->
							<!-- CALCULATOR -->
							<div
								class="flex"
								v-if="field.control === $constant.request.control.number || field.control === $constant.request.control.calculator"
							>
								<div class="text-black">
									<cbs-masked-input
										disabled
										dataType="int"
										class="masked-input-readonly"
										:userSetting="userSettings"
										v-model.number="field.value"
									/>
								</div>
							</div>


							<!-- RADIO -->
							<!-- DROPDOWN -->
							<div
								class="flex"
								v-if="
									field.control === $constant.request.control.radio ||
									field.control === $constant.request.control.dropdown
								"
							>
								<div class="text-black">
									{{ renderOptionsControlValue(field) }}
								</div>
							</div>

							<!-- RELATION -->
							<div
								class="flex"
								v-if="field.control === $constant.request.control.relation"
							>
								<div class="text-black w-48" v-if="field.value && field.value.length">
									{{ field.value.map(id => {
										const parsedAttributes = typeof field.attributes === "string" ? JSON.parse(field.attributes) : field.attributes;
										const selectedOption = (relations[parsedAttributes.related_model.split('\\').join('')] && relations[parsedAttributes.related_model.split('\\').join('')].data || []).find(option => option.id === id);
										return selectedOption && selectedOption.content || "";
									}).join(", ") }}
								</div>
							</div>

							<!-- CHECKBOX -->
							<div class="flex" v-if="field.control === $constant.request.control.checkbox">
								<div class="text-black">
									{{ renderOptionsControlValue(field, true) }}
								</div>
							</div>

							<!-- REPEATER -->
							<div class="flex" v-if="field.control === $constant.request.control.repeater">
								<i class="nucleo nucleo-layout-grid cursor-pointer" v-if="field.value && field.value.length"></i>
							</div>

							<!-- LABEL -->
							<label-content
								v-if="field.control === $constant.request.control.label"
								:value="field"
							/>
						</vs-td>
					</tr>
				</draggable>
			</vs-table>
		</perfect-scrollbar>
	</div>
</template>

<script>
import _ from "lodash";
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import Draggable from "vuedraggable";
import LabelContent from "./LabelContent";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

const isInvalidData = obj => {
	if (!_.isObject(obj)) {
		return true;
	}
	return (
		!_.has(obj, "id") ||
		!_.has(obj, "title") ||
		!_.has(obj, "value") ||
		!_.has(obj, "control") ||
		!_.has(obj, "children") ||
		!_.has(obj, "is_optional")||
		!_.has(obj, "description")
	);
}

export default {
	name: "RepeaterContent",
	components: { Draggable, CbsUploadRef, LabelContent },
	props: {
		value: {
			type: Object,
			validator: prop => {
				if(!_.isEmpty(prop)) {
					return !isInvalidData(prop);
				}
				return true;
			}
		},
		mappedAttachObj: {
			type: Object,
			default() {
				return {};
			}
		},
		isEditable: Boolean
	},
	emits: {
		onRemoveItem: {},
		onClickRepeaterData: {}
	},
	data() {
		return {
			relations: {},
			mappedRelationSelectedValues: {},

			options: {
				suppressScrollY: true, // disabled scroll Y
			}
		}
	},
	computed: {
		parsedModelValue() {
			return this.value && this.value.value && typeof this.value.value === "string" ? JSON.parse(this.value.value) : this.value.value;
		},
		parsedModelChildren() {
			return this.value && this.value.children && typeof this.value.children === "string" ? JSON.parse(this.value.children) : this.value.children;
		},
		stepTitles() {
			if (this.repeaterMappedValue && this.repeaterMappedValue.length) {
				return this.repeaterMappedValue[0].map(field => field.title);
			}

			return [];
		},
		repeaterMappedValue: {
			get() {
				return !_.isEmpty(this.parsedModelValue) && _.isArray(this.parsedModelValue) ? this.parsedModelValue.map(objValue =>
					this.parsedModelChildren.map(field => ({
						...field,
						value: objValue[field.id]
					}))
				) : [];
			},
			set(value) {
				this.$emit('input', Object.assign({}, {
					...this.value,
					value: value.map(
						form => {
							const data = {};
							form.forEach(field => data[field.id] = field.value);
							return data;
						}
					)
				}));
			}
		}
	},
	watch: {
		repeaterMappedValue() {
			this.setInitRelations();
		}
	},
	methods: {
		async setInitRelations() {
			if(!_.isEmpty(this.repeaterMappedValue)) {
				try {
					let isNeedUpdateRelationData = false;
					this.repeaterMappedValue.forEach(form => {
						form.forEach(field => {
							const parsedAttributes = typeof field.attributes === "string" ? JSON.parse(field.attributes) : field.attributes;
							const existOptionIds = this.mappedRelationSelectedValues[parsedAttributes.related_model] || [];
							if(field.control === this.$constant.request.control.relation && !_.isEmpty(field.value)) {
								if(field.value.some(optionId => !existOptionIds.includes(optionId)) || _.isEmpty(existOptionIds)) {
									this.mappedRelationSelectedValues[parsedAttributes.related_model] = existOptionIds.concat(field.value);
									isNeedUpdateRelationData = true;
								}
							}
						});
					});

					if(isNeedUpdateRelationData && !_.isEmpty(this.mappedRelationSelectedValues)) {
						this.$vs.loading();
						const response = await requestV2GQL.getCombinedRelationDataByModel(this.mappedRelationSelectedValues)
						this.relations = response || {};
					}
				} catch (error) {
					this.$helper.notifyError({ error, context: this });
				} finally {
					this.$nextTick(() => this.$vs.loading.close());
				}
			}
		},
		renderOptionsControlValue(controlData = {}, isMultipleValue = false) {
			const parsedAttributes = typeof controlData.attributes === "string" ? JSON.parse(controlData.attributes) : controlData.attributes;
			if (!parsedAttributes || !parsedAttributes.options) {
				return null;
			}
			if (!isMultipleValue) {
				return _.get(parsedAttributes.options.find(option => option.id == controlData.value) || {}, "content");
			}
			return controlData.value.map(id => _.get(parsedAttributes.options.find(option => option.id == id) || {}, "content")).join(", ");
		}
	},
	created() {
		this.setInitRelations();
	}
};
</script>

<style lang="scss" scoped>
.repeater-content {
	::v-deep .repeater-table {
		&.vs-con-table {
			.vs-table {
				.img-container {
					&::before {
						white-space: nowrap;
					}
				}
			}
		}
	}
	.masked-input-readonly {
		border: 0;
		background: 0;
		height: auto;
	}
}
</style>
